
/**
 * @description
 * 로드맵 > summary 수업 태그
 */

import { TagEnums } from '@/utils/tag/constants.js';
import { mapGetters } from 'vuex';

import Tag from '@/components/common/tag/Tag.vue';

export default {
  name: 'TagList',
  components: { Tag },
  data() {
    return {
      TagEnums,
    };
  },
  computed: {
    ...mapGetters('course', ['category']),
    categoryTagList: ({ category, TagEnums }) => {
      if (!category) return [];

      const { name, parentName } = category;

      const returnCategory = [];

      if (name) returnCategory.push({ tagText: name, tagType: TagEnums.INFO });
      if (parentName)
        returnCategory.push({ tagText: parentName, tagType: TagEnums.INFO });

      return returnCategory;
    },
    tagList: ({ categoryTagList }) => [...categoryTagList],
  },
};
